import moment from "moment";

export const formatTimeDataToUtc = (time: string | Date | undefined) => {
  return moment(time).utc().format("HH:mm");
};
